import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchedStandardRecordRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.standardRecordsCreate>[0]) =>
      SSF.api.standardRecordsCreate(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ...payload }: { id: number } & PatchedStandardRecordRequest) =>
      SSF.api.standardRecordsPartialUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteStandardRecordMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.standardRecordsDestroy>[0]) =>
      SSF.api.standardRecordsDestroy(variables),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
